var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6187 0C16.6746 0 16.7304 0 16.7894 0C16.9264 1.69253 16.2804 2.95719 15.4953 3.87301C14.7249 4.78251 13.67 5.6646 11.9637 5.53076C11.8499 3.86247 12.497 2.69161 13.2811 1.77789C14.0083 0.92636 15.3414 0.168621 16.6187 0Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7837 17.6166C21.7837 17.6335 21.7837 17.6482 21.7837 17.6641C21.3042 19.1163 20.6203 20.3609 19.7856 21.516C19.0236 22.5646 18.0899 23.9757 16.4227 23.9757C14.982 23.9757 14.0251 23.0494 12.5486 23.0241C10.9867 22.9988 10.1278 23.7987 8.69982 24C8.53647 24 8.37312 24 8.21293 24C7.16432 23.8482 6.31805 23.0178 5.70153 22.2695C3.88359 20.0585 2.47877 17.2025 2.21741 13.5476C2.21741 13.1893 2.21741 12.832 2.21741 12.4737C2.32806 9.85797 3.59904 7.73124 5.28841 6.70054C6.17999 6.15253 7.40566 5.68566 8.77043 5.89432C9.35533 5.98496 9.95288 6.1852 10.4767 6.38333C10.973 6.57408 11.5938 6.91237 12.1818 6.89446C12.5802 6.88286 12.9765 6.67525 13.378 6.52876C14.5541 6.10405 15.7071 5.61715 17.2268 5.84585C19.0531 6.12196 20.3494 6.93345 21.1504 8.18546C19.6054 9.16873 18.3839 10.6505 18.5926 13.1808C18.7781 15.4794 20.1144 16.8241 21.7837 17.6166Z",
    fill: "#202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b7f0b4d60b800e66f03df8097a5fd682.svg";
export { ForwardRef as ReactComponent };